














import Vue from 'vue'
import Component from 'vue-class-component'
import { IRadioGroupItem } from '@/interfaces'

@Component({
  props: {
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: [String, Number, Boolean],
      required: true
    }
  }
})
export default class RadioInlineGroup extends Vue {
  selectItem (item: IRadioGroupItem) {
    this.$emit('select', item)
  }

  isActive (item: IRadioGroupItem) {
    return this.$props.selected === item.value
  }
}
